<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="终端主机号"
             style="width: 200px; margin-right: 3px;"></Input>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onExportExcelClick">导出</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="addPositioningDeviceInfoModal=true">
        添加定位设备信息
      </Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="quicklyGenerateCertificateModal=true">
        快速生成证明
      </Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="quicklyGenerateInsuranceVideoCommitmentModal=true">
        快速生成保险承诺函
      </Button>
      <Upload style="display: inline-block;max-height: 23.99px;margin-right: 3px;" :on-success="onUploadSuccess"
              action="/api/im/positioningdeviceinfo/uploadpositioningdeviceinfosfile">
        <Button size="small" type="primary">批量导入定位设备信息</Button>
      </Upload>

      <Upload style="display: inline-block;max-height: 23.99px;margin-right: 3px;" :on-success="onUploadSuccess"
              action="/api/im/positioningdeviceinfo/modifypositioningdeviceinfosfile">
        <Button size="small" type="primary">批量修改定位设备信息</Button>
      </Upload>

      <Button v-if="positioningDeviceInfoList.length > 1" type="primary" size="small" style="margin-right: 3px;" @click="positioningDeviceInfoChangeInstallerModal=true">批量绑定师傅</Button>

    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content"
                 ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange"
                 @contextmenu.prevent.native="onTableRightClick($event)"
                 @on-selection-change="onselectionchange"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator
              @on-change="setPage" show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <add-positioning-device-info-modal v-model="addPositioningDeviceInfoModal"
                                       @on-success="onSuccess"></add-positioning-device-info-modal>
    <positioning-device-info-detail-modal v-model="positioningDeviceInfoDetailModal"
                                          :initValue="positioningDeviceInfoDetailId"
                                          @on-success="onModifySuccess"></positioning-device-info-detail-modal>
    <assemble-sim-modal v-model="assembleSimModal" :initValue="assembleSimDeviceId"
                        @on-success="onModifySuccess"></assemble-sim-modal>
    <quickly-generate-certificate-modal v-model="quicklyGenerateCertificateModal"></quickly-generate-certificate-modal>
    <quickly-generate-insurance-video-commitment-modal v-model="quicklyGenerateInsuranceVideoCommitmentModal"></quickly-generate-insurance-video-commitment-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name"
                             v-model="webTableColumnsModal" @on-column-update="onColumnUpdate"></web-table-columns-modal>
    <postitioning-device-info-change-installer-modal v-model="positioningDeviceInfoChangeInstallerModal" :initValue="positioningDeviceInfoChangeInstallerId" :listValue="positioningDeviceInfoList" @on-success="onModifySuccess"></postitioning-device-info-change-installer-modal>
  </div>
</template>

<script>
import AddPositioningDeviceInfoModal from '@/view/im/components/add-positioning-device-info-modal'
import PositioningDeviceInfoDetailModal from '@/view/im/components/positioning-device-info-detail-modal'
import AssembleSimModal from '@/view/im/components/assemble-sim-modal'
import QuicklyGenerateCertificateModal from '@/view/im/components/quickly-generate-certificate-modal'
import QuicklyGenerateInsuranceVideoCommitmentModal from '@/view/im/components/quickly-generate-insurance-video-commitment-modal'
import PostitioningDeviceInfoChangeInstallerModal from '@/view/im/components/postitioning-device-info-change-installer-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'
import { genURLParams } from '@/libs/urlparamhelper'
import Quicklygeneratecertificate
  from './components/quickly-generate-certificate-modal/quickly-generate-certificate-modal'

export default {
  name: 'positioningdeviceinfos',
  components: {
    QuicklyGenerateCertificateModal,
    QuicklyGenerateInsuranceVideoCommitmentModal,
    PostitioningDeviceInfoChangeInstallerModal,
    AssembleSimModal,
    AddPositioningDeviceInfoModal,
    PositioningDeviceInfoDetailModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      sourceTypeFilter: null,
      positioningDeviceModelFilter: null,

      positioningDeviceInfoStateOptions: [
        { label: '未安装', value: 1 },
        { label: '已安装', value: 2 },
        { label: '损坏', value: 3 }
      ],
      positioningDeviceModelOptions: [
      //   { label: 'BSJ-A6-BD', value: 1 },
      //   { label: 'BSJ-GF03', value: 2 },
      //   { label: 'BSJ-M11', value: 3 },
      //   { label: 'BSJ-A6L', value: 13 },
      //   { label: 'BSJ-A7', value: 14 },
      //   { label: 'K5', value: 4 },
      //   { label: 'D5X', value: 5 },
      //   { label: 'G-3G', value: 6 },
      //   { label: 'D5X-HDD', value: 7 },
      //   { label: 'D5X-XR', value: 8 },
      //   { label: 'BSJ-GF06', value: 9 },
      //   { label: 'BSJ-RM01', value: 10 },
      //   { label: 'HIK-A3', value: 11 },
      //   { label: 'HIK-A3L', value: 12 }
      ],
      positioningDeviceSourceTypeOptions: [
        { label: '新装', value: 1 },
        { label: '接入', value: 2 }
      ],
      // 安装维修员列表
      installers: [],

      quicklyGenerateCertificateModal: false,

      // 保险承诺函
      quicklyGenerateInsuranceVideoCommitmentModal: false,

      // 设备主机绑定安装维修员
      positioningDeviceInfoChangeInstallerModal: false,
      positioningDeviceInfoChangeInstallerId: null,
      positioningDeviceInfoList: [],

      // 添加收入项
      addPositioningDeviceInfoModal: false,

      // 定位设备信息详细信息
      positioningDeviceInfoDetailModal: false,
      positioningDeviceInfoDetailId: null,

      // 装配SIM卡
      assembleSimModal: false,
      assembleSimDeviceId: null,

      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 100
        },
        {
          title: '主机号',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          width: 150
        },
        {
          title: 'SIM卡号',
          resizable: true,
          key: 'simInfos',
          ellipsis: 'true',
          width: 150,
          render: function (h, params) {
            if (params.row.simInfos) {
              let simInfos = params.row.simInfos
              let displaySims = null
              let d = []
              if (simInfos.length > 1) {
                displaySims = ''
                simInfos.forEach(item => {
                  displaySims += displaySims + item.simNum + ','
                })
                d.push(h('div', display))
                return h('div', d)
              } else {
                return h('div', params.row.simInfos[0].simNum)
              }
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '出厂主机号',
          resizable: true,
          key: 'factoryTerminalNum',
          ellipsis: 'true',
          width: 150
        },
        {
          title: '加密芯片号',
          resizable: true,
          key: 'encryptionChipNumber',
          ellipsis: 'true',
          width: 150
        },
        {
          title: '设备型号',
          resizable: true,
          key: 'positioningDeviceModelId',
          ellipsis: 'true',
          width: 150,
          filters: [
            // { label: 'BSJ-A6-BD', value: 1 },
            // { label: 'BSJ-GF03', value: 2 },
            // { label: 'BSJ-M11', value: 3 },
            // { label: 'BSJ-A6L', value: 13 },
            // { label: 'BSJ-A7', value: 14 },
            // { label: 'K5', value: 4 },
            // { label: 'D5X', value: 5 },
            // { label: 'G-3G', value: 6 },
            // { label: 'D5X-HDD', value: 7 },
            // { label: 'D5X-XR', value: 8 },
            // { label: 'BSJ-GF06', value: 9 },
            // { label: 'BSJ-RM01', value: 10 },
            // { label: 'HIK-A3', value: 11 },
            // { label: 'HIK-A3L', value: 12 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.positioningDeviceModelFilter = genQueryParam('positioningDeviceModelId', 'EQ', val[0])
            } else {
              this.positioningDeviceModelFilter = null
            }
          },
          render: function (h, params) {
            if (params.row.positioningDeviceModel) {
              let positioningDeviceModel = params.row.positioningDeviceModel
              return h('div', positioningDeviceModel.name)
            } else {
              return h('div', '未知')
            }
            // let positioningDeviceModel = params.row.positioningDeviceModelId
            // if (positioningDeviceModel === 1) {
            //   return h('div', 'BSJ-A6-BD')
            // } else if (positioningDeviceModel === 2) {
            //   return h('div', 'BSJ-GF03')
            // } else if (positioningDeviceModel === 3) {
            //   return h('div', 'BSJ-M11')
            // } else if (positioningDeviceModel === 13) {
            //   return h('div', 'BSJ-A6L')
            // } else if (positioningDeviceModel === 14) {
            //   return h('div', 'BSJ-A7')
            // } else if (positioningDeviceModel === 4) {
            //   return h('div', 'K5')
            // } else if (positioningDeviceModel === 5) {
            //   return h('div', 'D5X')
            // } else if (positioningDeviceModel === 6) {
            //   return h('div', 'G-3G')
            // } else if (positioningDeviceModel === 7) {
            //   return h('div', 'D5X-HDD')
            // } else if (positioningDeviceModel === 8) {
            //   return h('div', 'D5X-XR')
            // } else if (positioningDeviceModel === 9) {
            //   return h('div', 'BSJ-GF06')
            // } else if (positioningDeviceModel === 10) {
            //   return h('div', 'BSJ-RM01')
            // } else if (positioningDeviceModel === 11) {
            //   return h('div', 'HIK-A3')
            // } else if (positioningDeviceModel === 12) {
            //   return h('div', 'HIK-A3L')
            // } else {
            //   return h('div', '未知')
            // }
          }
        },
        {
          title: '设备来源',
          resizable: true,
          key: 'sourceType',
          ellipsis: 'true',
          width: 120,
          filters: [
            {
              label: '新装',
              value: 1
            },
            {
              label: '接入',
              value: 2
            }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.sourceTypeFilter = genQueryParam('sourceType', 'EQ', val[0])
            } else {
              this.sourceTypeFilter = null
            }
          },
          render: function (h, params) {
            let sourceType = params.row.sourceType
            if (sourceType === 1) {
              return h('div', '新装')
            } else if (sourceType === 2) {
              return h('div', '接入')
            }
          }
        },
        {
          title: '安装车辆',
          resizable: true,
          key: 'vehicleInfoId',
          ellipsis: 'true',
          width: 180,
          render: function (h, params) {
            if (!params.row.vehicleInfo) {
              return h('div', '无')
            }
            let vehicleInfo = params.row.vehicleInfo
            let display = null
            if (vehicleInfo.registrationNum) {
              display = vehicleInfo.registrationNum
            } else {
              display = vehicleInfo.vin
            }
            if (vehicleInfo.customName) {
              display = display + '(' + vehicleInfo.customName + ')'
            }
            return h('div', display)
          }
        },
        {
          title: '绑定安装订单',
          resizable: true,
          key: 'installOrderId',
          ellipsis: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.installOrder) {
              return h('div', params.row.installOrder.orderNum)
            }
          }
        },
        {
          title: '安装订单车牌号',
          resizable: true,
          key: 'installOrderId',
          ellipsis: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.installOrder) {
              if (params.row.installOrder.tempVehicleInfoId) {
                return h('div', params.row.installOrder.tempVehicleInfo.registrationNum == null ? params.row.installOrder.tempVehicleInfo.vin : params.row.installOrder.tempVehicleInfo.registrationNum)
              } else {
                return h('div', '无')
              }
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '绑定SIM卡号',
          resizable: true,
          key: 'siminfos',
          ellipsis: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.installOrder) {
              return h('div', params.row.installOrder.orderNum)
            }
          }
        },
        {
          title: '分配师傅',
          resizable: true,
          key: 'installer',
          ellipsis: 'true',
          width: 180,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.installerFilter = []
              val.forEach(item => {
                if (item == null) {
                  this.installerFilter.push(genQueryParam('installerId', 'EQNULL'))
                } else {
                  this.installerFilter.push(genQueryParam('installerId', 'EQ', item))
                }
              })
            } else {
              this.installerFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            if (params.row.installerId) {
              return h('div', params.row.installer.realName != null ? params.row.installer.realName : params.row.installer.nickName != null ? params.row.installer.nickName : params.row.installer.name)
            } else {
              return h('div', {
                style: {
                  color: 'red'
                }
              }, '未分配')
            }
          }
        },
        {
          title: '备注',
          resizable: true,
          key: 'remark',
          ellipsis: 'true',
          tooltip: 'true',
          width: 100
        },
        {
          title: '安装时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'setupDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.setupDatetime) {
              let d = new Date(params.row.setupDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '服务到费时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'serviceDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.serviceDatetime) {
              let d = new Date(params.row.serviceDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '厂家质保期',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'factoryGuaranteePeriod',
          width: 180,
          render: function (h, params) {
            if (params.row.factoryGuaranteePeriod) {
              let d = new Date(params.row.factoryGuaranteePeriod)
              return h('div', d.Format('yyyy年MM月dd日'))
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '客户质保期',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'clientGuaranteePeriod',
          width: 180,
          render: function (h, params) {
            if (params.row.clientGuaranteePeriod) {
              let d = new Date(params.row.clientGuaranteePeriod)
              return h('div', d.Format('yyyy年MM月dd日'))
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '历史记录',
          resizable: true,
          key: 'historyRecord',
          ellipsis: 'true',
          tooltip: 'true',
          minWidth: 100
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 200,
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.positioningDeviceInfoDetailId = params.row.id
                    this.positioningDeviceInfoDetailModal = true
                  }
                }
              }, '详细信息'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.assembleSimDeviceId = params.row.id
                    this.assembleSimModal = true
                  }
                }
              }, '配卡'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.handleSelectAll(false)
                    this.positioningDeviceInfoChangeInstallerId = params.row.id
                    this.positioningDeviceInfoChangeInstallerModal = true
                  }
                }
              }, '绑定师傅')
            ])
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'PositioningDeviceInfoServ_GetPage'
    ]),
    /**
     * 批量选择功能
     */
    onselectionchange (selection) {
      console.log(selection)
      this.positioningDeviceInfoList = selection
      // if (selection.length > 0) {
      //   selection.forEach(item => {
      //     this.installOrderIds.push(item.id)
      //   })
      // }else {
      //   this.installOrderIds = []
      // }
      // console.log(this.simInfoList.length)
    },
    handleSelectAll (status) {
      this.$refs.table.selectAll(status)
    },
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onUploadSuccess (rsp) {
      if (rsp.code === 200) {
        this.$Message.success(rsp.msg)
        this.$Message.success('导入成功')
        this.setPage(1)
      } else {
        this.$Message.error(rsp.msg)
      }
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onFilterClick () {
      this.setPage(1)
    },
    onExportExcelClick () {
      // let queryParams = []
      // let qo1 = null
      // let qo2 = null
      // if (this.stateFilter) {
      //   qo1 = this.stateFilter
      // }
      // if (this.offlineFilter) {
      //   qo2 = this.offlineFilter
      // }
      // if (this.selectAnalysisDatetime[0] && this.selectAnalysisDatetime[1]) {
      //   let startDatetime = new Date(this.selectAnalysisDatetime[0]).Format('yyyy-MM-dd 00:00:00')
      //   let endDatetime = new Date(this.selectAnalysisDatetime[1]).Format('yyyy-MM-dd 23:59:59')
      //   queryParams.push(genQueryParam('analyzeDatetime', 'BTDT', startDatetime, endDatetime))
      // }
      console.log('AA')
      let urlparams = {
        keyword: this.keywordFilter
      }
      let url = '/api/im/positioningdeviceinfo/exportexcel' + genURLParams(urlparams)
      window.location.href = url
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    filterChange () {
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }

      if (this.sourceTypeFilter) {
        queryParams.push(this.sourceTypeFilter)
      }
      if (this.positioningDeviceModelFilter) {
        queryParams.push(this.positioningDeviceModelFilter)
      }

      store.dispatch('PositioningDeviceInfoServ_GetPage', {
        params: null,
        urlparams: {
          q: queryParams,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
        this.onColumnUpdate()
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    },
    onColumnUpdate () {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '设备型号') {
          this.columns[i].filters = this.positioningDeviceModelOptions
          break
        }
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '分配师傅') {
          this.columns[i].filters = this.installers
          break
        }
      }
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_PositioningDeviceInfo_GetPageResult) {
        return store.getters.get_PositioningDeviceInfo_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_PositioningDeviceInfo_GetPageResult) {
        return store.getters.get_PositioningDeviceInfo_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_PositioningDeviceInfo_GetPageResult) {
        return store.getters.get_PositioningDeviceInfo_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
      store.dispatch('PositioningDeviceTypeServ_GetAll', {
        params: {},
        urlparams: null
      }).then(() => {
        if (store.getters.get_PositioningDeviceType_GetAllResult) {
          this.positioningDeviceModelOptions = store.getters.get_PositioningDeviceType_GetAllResult.map(item => { return { label: item.name, value: item.id } })
        }
      }).catch(err => {
        console.log(err)
      })

      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [8, 14] }
      }).then(() => {
        let installers = []
        store.getters.get_User_GetAllUsersResult.forEach(item => {
          if (item.state === 1) {
            installers.push({ label: item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name, value: item.id })
          }
        })
        this.installers = installers
      }).catch(err => {
        this.$Message.error(err)
      })
    })
  }
}
</script>

<style scoped>
</style>
